const config = {
  URL: "https://ecasenka.wame.sk",
  URLHOME: "https://www.ecasenka.sk",
  API: "https://api.ecasenka.sk/frontapi",
  ESHOP_API: "https://eshop.ecasenka.wame.sk/api",
  PAYMENTS_API: "https://platby.ecasenka.wame.sk/api",
  GOOGLE: "https://maps.google.com/?q=",
  LANGUAGE: "sk",
  SOCKET: "wss://api.ecasenka.sk/realtime/realtime/",
  TIME: 1800,
  REFRESH: 60000,
  ROUTE_PREFIX: '/ordinacia',
};

export default config;
